import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  skeleton: {
    transform: "none",
    width: "100%",
    height: 52,
  },
  inputSkeleton: {
    marginTop: "18px",
  },
}));

export default styles;
